var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap h-full"},_vm._l((_vm.tags),function(tag,index){return _c('div',{key:index},[_c('TagIconItem',{attrs:{"tag":tag,"selected-tag-type":_vm.value},on:{"update:selected-tag-type":function($event){return _vm.$emit('input', $event)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }